import { Component, OnInit } from '@angular/core';
import { ICiiuCode } from 'src/app/shared/interfaces/ciuu-code.interface';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  AbstractControl,
  Validators
} from '@angular/forms';
import { Observable } from 'rxjs';
import { EnumEconomicActivity } from 'src/app/shared/enums/economic-activity.enum';
import { Router } from '@angular/router';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { CustomValidators } from 'src/app/shared/validators/custom-validators.validators';
import { startWith, map } from 'rxjs/operators';
import { ciiuCodes } from 'src/app/shared/data/ciiu-codes.json';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { RegExps } from 'src/app/shared/resources/regexps.constant';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { AnalyticService } from 'src/app/shared/services/analytic.service';

@Component({
  selector: 'app-economic-activity',
  templateUrl: './economic-activity.component.html',
  styleUrls: ['./economic-activity.component.scss']
})
export class EconomicActivityComponent implements OnInit {
  economicActivityForm: UntypedFormGroup = {} as UntypedFormGroup;
  filteredOptions: Observable<ICiiuCode[]> = new Observable();
  normalizeForm = 'NFD';
  radioGroup: any[] = [
    {
      value: EnumEconomicActivity.Employee,
      text: 'Empleado',
      iconClass: 'icon-pagos'
    },
    {
      value: EnumEconomicActivity.Independent,
      text: 'Independiente',
      iconClass: 'icon-negocios_ventas'
    },
    {
      value: EnumEconomicActivity.Student,
      text: 'Estudiante',
      iconClass: 'icon-educacion'
    },
    {
      value: EnumEconomicActivity.WorkHome,
      text: 'Hogar',
      iconClass: 'icon-casa_apto'
    },
    {
      value: EnumEconomicActivity.Pensioner,
      text: 'Pensionado',
      iconClass: 'icon-mis_otros_creditos'
    }
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private customerDataService: CustomerDataService,
    private router: Router,
    private moreInfoService: MoreInfoService,
    public analytic: AnalyticService
  ) {}

  get controlCodeCIIU(): AbstractControl {
    return this.economicActivityForm.get('codeCIIU');
  }

  get controlEconomicActivity(): AbstractControl {
    return this.economicActivityForm.get('economicActivity');
  }

  ngOnInit() {
    this.economicActivityForm = this.fb.group({
      economicActivity: [null, Validators.required],
      codeCIIU: [
        { value: null, disabled: true },
        [Validators.required, CustomValidators.notAString]
      ]
    });

    this.filterOptions();
    this.valueChanges();
  }

  updateCustomerData(): void {
    const value = this.economicActivityForm.value;

    this.customerDataService.customerData = {
      ...this.customerDataService.customerData,
      ...{
        economicActivityInformation: {
          economicActivity: value.economicActivity,
          codeCiiu: value.codeCIIU
        }
      }
    };
  }

  valueChanges(): void {
    this.controlEconomicActivity.valueChanges.subscribe((value) => {
      this.controlCodeCIIU.setValue('');
      if (
        value === EnumEconomicActivity.Independent ||
        value === EnumEconomicActivity.IndependentWithBusiness
      ) {
        this.controlCodeCIIU.enable();
      } else {
        this.controlCodeCIIU.disable();
      }
    });
  }

  closedEmitter(): void {
    const valuePossibleCode = this.controlCodeCIIU.value;
    const codeMaybe =
      typeof valuePossibleCode === 'string' && valuePossibleCode.length >= 3
        ? this._filter(valuePossibleCode)
        : null;
    if (codeMaybe?.length) {
      this.controlCodeCIIU.setValue(codeMaybe[0]);
    }
  }

  displayFn(codeCiiu?: ICiiuCode): string | undefined {
    return codeCiiu ? codeCiiu.name : undefined;
  }

  filterOptions(): void {
    this.filteredOptions = this.controlCodeCIIU.valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter(name) : ciiuCodes.slice()))
    );
  }

  onSubmit(): void {
    try {
      this.updateCustomerData();

      if (
        this.customerDataService.customerData.economicActivityInformation
          .codeCiiu?.isExcludes
      ) {
        this.analytic.uTagLinkError(
          'Error código ciuu excluido ' +
            JSON.stringify(
              this.customerDataService.customerData.economicActivityInformation
                .codeCiiu
            ),
          'error_user_page'
        );
        this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
      } else {
        this.router.navigate(
          this.customerDataService.customerData.client &&
            this.customerDataService.customerData.updated
            ? [routesData.NONDECLARATING_QUESTION.redirectPath]
            : [routesData.CONTACT_INFORMATION.redirectPath]
        );
      }
    } catch (err) {
      const errorMessage = err.message === undefined ? '' : err.message;
      this.analytic.uTagLinkError(
        'Error catch submit actividad económica ' + errorMessage,
        'error_tech_page'
      );
      this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
    }
  }

  private _filter(name: string): ICiiuCode[] {
    const filterValue = name
      .toLowerCase()
      .normalize(this.normalizeForm)
      .replace(RegExps.DIACRITICAL_MARKS, '');

    return ciiuCodes.filter((ciiuCode) =>
      ciiuCode.name
        .toLowerCase()
        .normalize(this.normalizeForm)
        .replace(RegExps.DIACRITICAL_MARKS, '')
        .includes(filterValue)
    );
  }
}
